export const B2B_INDUSTRIES = [
  'sports_club',
  'company',
  'school',
  'university',
  'community',
  'non_profit',
  'government',
  'other',
] as const

export type B2bIndustry = (typeof B2B_INDUSTRIES)[number]

export const B2B_INDUSTRY_LABELS: Record<B2bIndustry, string> = {
  sports_club: 'Sports Club',
  company: 'Company',
  school: 'School',
  university: 'University',
  community: 'Community',
  non_profit: 'Non-Profit',
  government: 'Government',
  other: 'Other',
}
